import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { AssetTrackingService } from 'src/app/services/asset-tracking.service'
import { AssetManagementService } from 'src/app/services/asset-management.service'
import { AssetInventoryServiceService } from 'src/app/services/asset-inventory-service.service'
import { assetData, History, newHistory } from 'src/app/models/asset-tracking.model'
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators'
import { ApiService } from '../../../services/api.service'
import { Employee } from 'src/app/models/asset-inventory.model'
import { Company, ConfigValue } from 'src/app/models/asset-config.model'
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload'
import { Observable, Observer } from 'rxjs'
import { NzMessageService } from 'ng-zorro-antd/message'
import { CapitalizeWord } from './../../../shared/pipes/capitalize-word.pipe'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzImageService } from 'ng-zorro-antd/image'
import { NzTableQueryParams } from 'ng-zorro-antd/table'

@Component({
  selector: 'app-asset-tracking',
  templateUrl: './asset-tracking.component.html',
  styleUrls: ['./asset-tracking.component.scss'],
})
export class AssetTrackingComponent implements OnInit {
  @ViewChild('toaster', { static: true }) toasterTemplate: TemplateRef<{}>
  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1

  employeeList: Employee[] = []
  departmentList: ConfigValue[] = []
  statusList: ConfigValue[] = []
  conditionList: ConfigValue[] = []
  locationList: ConfigValue[] = []
  employeePictList: NzUploadFile[] = []
  assetPictList: NzUploadFile[] = []

  assetList: assetData[] = []
  companyList: Company[] = []
  selectedAsset: assetData
  selectedHistory: History
  filterForm: FormGroup
  assetsForm: FormGroup

  viewModalVisible: boolean = false
  viewHistoryImageSrc: any[] = []

  showHistoryEmployeePicture: string
  showHistoryAssetPicture: any[]
  showHistoryDetail: boolean

  addModalVisible: boolean = false
  addModalConfirm: boolean = false
  addModalLoading: boolean = false
  loading = false
  previewImage: string | undefined = ''
  previewVisible = false

  statusFiltered: string = 'Total'
  isDownloading: boolean = false

  toasterIcon: string
  toasterColor: string
  toasterMessage: string

  imageFallback =
    'data:image/png;base64,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'

  constructor(
    private assetInventoryService: AssetInventoryServiceService,
    private assetManagementService: AssetManagementService,
    private assetTrackingService: AssetTrackingService,
    private apiService: ApiService,
    private modal: NzModalService,
    private msg: NzMessageService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private nzImageService: NzImageService,
  ) {
    this.filterForm = this.fb.group({
      assetNumber: [''],
    })

    this.assetsForm = this.fb.group({
      selectedEmployee: [null, Validators.compose([Validators.required])],
      employeeName: ['', Validators.compose([Validators.required])],
      assetNumber: ['', Validators.compose([Validators.required])],
      department: ['', Validators.compose([Validators.required])],
      employeePicture: [''],
      company: ['', Validators.compose([Validators.required])],
      phoneNumber: ['', Validators.compose([Validators.required])],
      email: [''],
      assetName: ['', Validators.compose([Validators.required])],
      serialNumber: [''],
      status: ['', Validators.compose([Validators.required])],
      service: [null, Validators.compose([Validators.pattern('^[0-9]*$')])],
      serviceAt: [''],
      location: ['', Validators.compose([Validators.required])],
      assetPicture: ['', Validators.compose([Validators.required])],
      type: ['', Validators.compose([Validators.required])],
      brand: ['', Validators.compose([Validators.required])],
      condition: ['', Validators.compose([Validators.required])],
      description: [''],
      purchasedDate: ['', Validators.compose([Validators.required])],
      initialValue: [null, Validators.compose([Validators.required])],
      depreciationRate: [
        null,
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+([.][0-9]+)?$')]),
      ],
      period: [null, Validators.compose([Validators.required, Validators.pattern('^[0-9]*$')])],
      note: [''],
    })
  }

  listOfColumns = [
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      width: '125px',
    },
    {
      name: 'Asset Number',
      key: 'assets_number',
      left: false,
      right: false,
      width: '230px',
      compare: (a: assetData, b: assetData) => a.asset_number.localeCompare(b.asset_number),
      priority: false,
    },
    {
      name: 'Asset Name',
      key: 'assets_name',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.asset_name.localeCompare(b.asset_name),
      priority: false,
    },
    {
      name: 'Location',
      key: 'location',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.location.localeCompare(b.location),
      priority: false,
    },
    {
      name: 'Serial Number',
      key: 'serial_number',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.serial_number.localeCompare(b.serial_number),
      priority: false,
    },
    {
      name: 'Created By',
      key: 'created_by',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.created_by.localeCompare(b.created_by),
      priority: false,
    },
    {
      name: 'Created At',
      key: 'created_at',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.created_at.localeCompare(b.created_at),
      priority: false,
    },
    {
      name: 'Updated By',
      key: 'updated_by',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.updated_by.localeCompare(b.updated_by),
      priority: false,
    },
    {
      name: 'Updated At',
      key: 'updated_at',
      left: false,
      right: false,
      width: '200px',
      compare: (a: assetData, b: assetData) => a.updated_at.localeCompare(b.updated_at),
      priority: false,
    },
  ]

  listHistoryColumns = [
    {
      name: 'Action',
      key: 'action',
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Updated At',
      key: 'updated_at',
      left: false,
      right: false,
      width: '200px',
      compare: (a: History, b: History) => a.updated_at.localeCompare(b.updated_at),
      priority: false,
    },
    {
      name: 'Employee Name',
      key: 'employee_name',
      left: false,
      right: false,
      width: '200px',
      compare: (a: History, b: History) => a.employee_name.localeCompare(b.employee_name),
      priority: false,
    },
    {
      name: 'Department',
      key: 'department',
      left: false,
      right: false,
      width: '200px',
      compare: (a: History, b: History) => a.department.localeCompare(b.department),
      priority: false,
    },
    {
      name: 'Status',
      key: 'status',
      left: false,
      right: false,
      width: '200px',
      compare: (a: History, b: History) => a.department.localeCompare(b.department),
      priority: false,
    },
  ]

  ngOnInit(): void {
    this.fetchAsset('')
    this.filterAutoSearch()
    this.employeeAutoComplete()
    this.fetchCompay()
  }

  filterAutoSearch() {
    this.filterForm
      .get('assetNumber')
      .valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(value => this.filterAction(value)),
      )
      .subscribe()
  }

  filterAction(assetNumber: string) {
    if (assetNumber.length >= 15) {
      this.fetchAsset(assetNumber)
    }
    return []
  }

  fetchAsset(assetNumber: string) {
    this.isLoading = true
    this.assetTrackingService.getAssetList(assetNumber).subscribe(
      r => {
        this.assetList = r.rows
        this.totalData = r.count
        this.isLoading = false
        this.filterForm.get('assetNumber').setValue('')
        // console.log(r)
      },
      error => console.error(error),
    )
  }

  fetchCompay() {
    this.assetManagementService.getCompany().subscribe((r: Company[]) => {
      this.companyList = r
    })
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    console.log(params)
    const { pageSize, pageIndex, sort } = params
    this.pageSize = pageSize
  }

  async handleSelectCompany() {
    this.departmentList = []
    await this.fetchDepartment(this.assetsForm.value.company)
  }

  toggleAddHistory(asset: assetData) {
    this.fetchDepartment(asset.company)
    this.fetchCondition(asset.company)
    this.fetchLocation(asset.company)
    this.fetchStatus(asset.company)

    this.selectedAsset = asset
    // console.log(asset.asset_number)
    this.addModalVisible = true
    this.addModalLoading = true
    this.assetsForm.get('selectedEmployee').setValue(asset.employee_name)
    this.assetsForm.get('employeeName').setValue(asset.employee_name)
    this.assetsForm.get('department').setValue(asset.department)
    this.assetsForm.get('email').setValue(asset.asset_trackings[0].email)
    this.assetsForm.get('company').setValue(asset.company)
    this.assetsForm.get('assetNumber').setValue(asset.asset_number)
    // this.assetsForm.get('assetNumber').disable()
    this.assetsForm.get('serialNumber').setValue(asset.serial_number)
    this.assetsForm.get('serialNumber').disable()
    this.assetsForm.get('assetName').setValue(asset.asset_name)
    this.assetsForm.get('service').setValue(asset.asset_trackings[0].service)
    this.assetsForm.get('status').setValue(asset.asset_trackings[0].status)
    this.assetsForm.get('serviceAt').setValue(asset.asset_trackings[0].service_at)
    this.assetsForm.get('location').setValue(asset.location)
    this.assetsForm.get('description').setValue(asset.asset_trackings[0].description)
    this.assetsForm.get('note').setValue(asset.asset_trackings[0].note)
    this.assetsForm.get('assetName').disable()
    this.assetsForm.get('purchasedDate').setValue(new Date(asset.purchased_date))
    this.assetsForm.get('purchasedDate').disable()
    this.assetsForm.get('type').setValue(asset.type)
    this.assetsForm.get('brand').setValue(asset.brand)
    this.assetsForm.get('condition').setValue(asset.asset_trackings[0].condition)
    this.assetsForm.get('description').setValue(asset.asset_trackings[0].description)
    this.assetsForm.get('note').setValue(asset.asset_trackings[0].note)
    this.assetsForm
      .get('initialValue')
      .setValue(
        new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' })
          .format(asset.initial_value)
          .replace(/^.*\s/, ''),
      )
    this.assetsForm.get('initialValue').disable()
    this.assetsForm.get('depreciationRate').setValue(asset.deprecation_rate)
    this.assetsForm.get('depreciationRate').disable()
    this.assetsForm.get('period').setValue(asset.period)
    this.assetsForm.get('phoneNumber').setValue(asset.asset_trackings[0].phone_number)
    this.assetsForm.get('period').disable()

    this.addModalLoading = false
  }

  addHistoryOk() {
    if (!this.assetsForm.valid) return
    this.addModalConfirm = true
    setTimeout(() => {
      this.addModalConfirm = false
      this.addModalVisible = false
      const capitalizeWordPipe = new CapitalizeWord()
      const payload: newHistory = {
        assetNumber: this.assetsForm.value.assetNumber,
        employeeName: capitalizeWordPipe.transform(this.assetsForm.value.employeeName),
        department: this.assetsForm.value.department,
        serviceAt: this.assetsForm.value.serviceAt,
        company: this.assetsForm.value.company,
        phoneNumber: this.assetsForm.value.phoneNumber,
        email: this.assetsForm.value.email,
        status: this.assetsForm.value.status,
        service: this.assetsForm.value.service,
        location: this.assetsForm.value.location,
        condition: this.assetsForm.value.condition,
        description: this.assetsForm.value.description,
        note: this.assetsForm.value.note,
        employeePicture: this.assetsForm.value.employeePicture,
        assetPicture: this.assetsForm.value.assetPicture,
      }
      // console.log(payload)

      this.assetTrackingService.addNewHistory(payload).subscribe(
        r => {
          // console.log(r)
          this.toasterMessage = r.message
          this.toasterIcon = 'check-circle'
          this.toasterColor = '#52c41a'
          this.createBasicNotification(this.toasterTemplate)
          this.clearForm()
          this.fetchAsset('')
        },
        error => {
          // console.error(error)
          this.toasterMessage = error.error.message
          this.toasterIcon = 'warning'
          this.toasterColor = '#eb2f96'
          this.createBasicNotification(this.toasterTemplate)
        },
      )
    }, 500)
  }

  toggleCancelAddHistory() {
    this.addModalVisible = false
    this.clearForm()
  }

  clearForm(): void {
    this.assetsForm.get('selectedEmployee').setValue('')
    this.assetsForm.get('employeeName').setValue('')
    this.assetsForm.get('department').setValue('')
    this.assetsForm.get('employeePicture').setValue('')
    this.assetsForm.get('phoneNumber').setValue('')
    this.assetsForm.get('serialNumber').setValue('')
    this.assetsForm.get('status').setValue('')
    this.assetsForm.get('service').setValue('')
    this.assetsForm.get('serviceAt').setValue('')
    this.assetsForm.get('location').setValue('')
    this.assetsForm.get('assetPicture').setValue('')
    this.assetsForm.get('type').setValue('')
    this.assetsForm.get('brand').setValue('')
    this.assetsForm.get('condition').setValue('')
    this.assetsForm.get('description').setValue('')
    this.assetsForm.get('purchasedDate').setValue('')
    this.assetsForm.get('initialValue').setValue(null)
    this.assetsForm.get('depreciationRate').setValue(null)
    this.assetsForm.get('period').setValue(null)
    this.assetsForm.get('note').setValue('')
    this.assetPictList = []
    this.employeePictList = []
  }

  toggleViewHistory(asset: assetData) {
    this.selectedAsset = asset
    this.viewModalVisible = true
    this.viewHistoryImageSrc = asset.asset_trackings[0].asset_pictures.map(item => ({
      src: `${this.apiService.API_SUNSHINE_SERVER}/api/assetManagement/inventories/upload/${item.filename}`,
      alt: 'asset picture',
    }))
    // console.log(
    //   `${this.apiService.API_SUNSHINE_SERVER}/api/assetManagement/inventories/upload/${asset.asset_trackings[0].assets_picture}`,
    // )
    console.log(asset, 'view history')
  }
  toggleCancelViewHistory() {
    this.viewModalVisible = false
    this.fetchAsset(this.filterForm.value.assetNumber)
  }

  showHistory(history: History) {
    this.selectedHistory = history
    // console.log(history)
    // console.log(this.selectedAsset)
    this.showHistoryDetail = true
    this.showHistoryAssetPicture = history.asset_pictures.map(item => ({
      src: `${this.apiService.API_SUNSHINE_SERVER}/api/assetManagement/inventories/upload/${item.filename}`,
      alt: 'asset image',
    })) //`${this.apiService.API_SUNSHINE_SERVER}/api/assetManagement/inventories/upload/${history.assets_picture}`
    this.showHistoryEmployeePicture = `${this.apiService.API_SUNSHINE_SERVER}/api/assetManagement/inventories/upload/${history.employee_picture}`
    this.showHistoryDetail = true
  }
  cancelShowHistory() {
    this.showHistoryDetail = false
  }

  employeeAutoComplete() {
    this.assetsForm
      .get('selectedEmployee')
      .valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(value => this.searchEmployee(value)),
      )
      .subscribe()
  }

  searchEmployee(value: any) {
    this.assetsForm.get('phoneNumber').setValue('')
    if (typeof value === 'object') {
      this.assetsForm.get('employeeName').setValue(value.name)
      this.assetsForm.get('phoneNumber').setValue(value.wa_number.replace('+62', ''))
    }
    if (value.length >= 1) {
      this.assetsForm.get('employeeName').setValue(value)
      const payload = {
        value: value,
        type: 'employeeName',
      }
      this.assetInventoryService.getEmployee(payload).subscribe(
        r => (this.employeeList = r),
        error => console.error(error),
      )
    }
    return []
  }

  fetchDepartment(company: string) {
    this.assetsForm.get('department').setValue('')
    const config = 'Department'
    this.assetManagementService.getConfigValue(company, config).subscribe((r: ConfigValue[]) => {
      this.departmentList = r
    })
  }

  fetchStatus(company: string) {
    this.assetsForm.get('status').setValue('')
    const config = 'Status'
    this.assetManagementService.getConfigValue(company, config).subscribe((r: ConfigValue[]) => {
      this.statusList = r
    })
  }

  fetchCondition(company: string) {
    this.assetsForm.get('condition').setValue('')
    const config = 'Condition'
    this.assetManagementService.getConfigValue(company, config).subscribe((r: ConfigValue[]) => {
      // console.log(r)
      this.conditionList = r
    })
  }

  fetchLocation(company: string) {
    this.assetsForm.get('location').setValue('')
    const config = 'Location'
    this.assetManagementService.getConfigValue(company, config).subscribe((r: ConfigValue[]) => {
      // console.log(r)
      this.locationList = r
    })
  }

  formatNumber(event: any, formControl) {
    const inputValue = event.target.value
    const number = inputValue.replace(/[^\d]/g, '')
    this.assetsForm.get(formControl).setValue(number)
  }

  //file upload region
  customUpload = (item: NzUploadXHRArgs) => {
    const formData = new FormData()
    formData.append('file', item.file as any)
    this.assetInventoryService.uploadFile(formData).subscribe(
      r => {
        // console.log(r)
        item.onSuccess(r, item.file, r)
        this.toasterMessage = `Upload Success\n${item.file.name}`
        this.toasterIcon = 'check-circle'
        this.toasterColor = '#52c41a'
        this.createBasicNotification(this.toasterTemplate)
      },
      error => {
        // console.error(error)
        this.toasterMessage = 'Upload Error'
        this.toasterIcon = 'warning'
        this.toasterColor = '#eb2f96'
        this.createBasicNotification(this.toasterTemplate)
        item.onError(error, item.file)
      },
    )
  }

  getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      const maxSize = file.type === 'application/pdf' ? 50 * 1024 * 1024 : 2 * 1024 * 1024
      const isLt2M = file.size < maxSize
      console.log(file.size)
      if (!isLt2M) {
        this.toasterMessage = file.type === 'application/pdf' ? 'Pdf Max 50mb' : 'Image Max 2mb'
        this.toasterIcon = 'warning'
        this.toasterColor = '#eb2f96'
        this.createBasicNotification(this.toasterTemplate)
        observer.complete()
        return
      }
      observer.next(isLt2M)
      observer.complete()
    })

  handleChangeEmployee(info: { file: NzUploadFile }): void {
    // console.log(this.employeePictList, 'employee pict list')
    switch (info.file.status) {
      case 'uploading':
        this.loading = true
        break
      case 'done':
        // console.log(info.file.response, 'employee')
        this.assetsForm.get('employeePicture').setValue(info.file.response.name)
        break
      case 'error':
        this.msg.error('Network error')
        this.loading = false
        break
    }
  }

  handleChangeAsset(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.loading = true
        break
      case 'done':
        console.log(info.file.response, 'asset')
        const fileList = this.assetsForm.get('assetPicture').value
        console.log(fileList)
        this.assetsForm.get('assetPicture').setValue([...fileList, info.file.response.name])
        break
      case 'error':
        this.msg.error('Network error')
        this.loading = false
        break
    }
  }

  handleDownload = (file: NzUploadFile): void => {
    window.open((file.response?.url || file.url) + '?s=download', '_blank')
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj!)
    }
    this.previewImage = file.url || file.preview
    this.previewVisible = true
  }

  handleRemove = (file: NzUploadFile) => {
    console.log(file)
    this.assetInventoryService.deleteFile(file.response.name).subscribe(
      r => {
        // console.log(r)
        if (this.employeePictList[0] === file) this.employeePictList = []
        const assetPictureIndex = this.assetPictList.findIndex(item => item.name === file.name)
        if (assetPictureIndex >= 0) this.assetPictList.splice(assetPictureIndex, 1)
        console.log(assetPictureIndex, this.assetPictList)
      },
      error => console.error(error),
    )
  }

  exportHistory(assetNumber: string) {
    this.isDownloading = true
    var blankPage = window.open('http://example.com/waiting.html', '_blank')
    blankPage!.document.write('Loading preview...')

    this.assetTrackingService.exportHistory(assetNumber).subscribe(
      r => {
        // console.log(r.link)
        this.isDownloading = false
        blankPage!.location.href = r.link
        this.toasterMessage = r.message
        this.toasterIcon = 'check-circle'
        this.toasterColor = '#52c41a'
        this.createBasicNotification(this.toasterTemplate)
      },
      err => {
        blankPage.close()
        this.isDownloading = false
        this.toasterMessage = err.error.message
        this.toasterIcon = 'warning'
        this.toasterColor = '#eb2f96'
        this.createBasicNotification(this.toasterTemplate)
      },
    )
  }

  handleImagePreview(images) {
    this.nzImageService.preview(images)
  }

  createBasicNotification(template: TemplateRef<{}>): void {
    this.notification.template(template, {
      nzPlacement: 'bottomRight',
    })
  }
}
